export const createFullPageRegenerationConfirmation = (onConfirm) => ({
  title: 'Replace the entire portfolio?',
  message: 'The AI assistant will generate a completely new page. Your current page will stay unchanged until you review and apply the result.',
  confirmLabel: 'Regenerate full page',
  cancelLabel: 'Keep current page',
  busyLabel: 'Starting regeneration...',
  variant: 'danger',
  onConfirm,
});
